import { Modal, Text, Button } from "@mantine/core";
import "./ConfirmCloseModal.scss";

interface Props {
  modalOpened: boolean;
  closeModal: () => void;
  handleSelectNo: () => void;
  customText?: {
    text?: string;
    title?: string;
    buttonLabels?: {
      left?: string;
      right?: string;
    };
  };
}

const ConfirmCloseModal = ({
  modalOpened,
  closeModal,
  handleSelectNo,
  customText,
}: Props) => {
  return (
    <Modal
      opened={modalOpened}
      className="confirm-close-modal"
      onClose={handleSelectNo}
      title={customText?.title ?? "Confirm Close"}
      centered
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
    >
      <div>
        <Text className="confirm-close-modal-text">
          {customText?.text ??
            "Are you sure you want to close this modal? All unsaved changes will be lost."}
        </Text>

        <div className="confirm-close-modal-buttons">
          <Button
            onClick={handleSelectNo}
            style={{ marginRight: "1rem" }}
            variant="outline"
            color="#0077CC"
            className="confirm-btn"
            size="md"
          >
            {customText?.buttonLabels?.left ?? "No"}
          </Button>
          <Button
            onClick={closeModal}
            className="confirm-btn"
            color="red"
            size="md"
          >
            {customText?.buttonLabels?.right ?? "Yes"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmCloseModal;
